import { Component, Input } from '@angular/core';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { EventViewModel } from '../../../models-views/event.view.model';
import { ActivatedRoute } from '@angular/router';
import { QuotationRequestModel, QuotationRequestResponseModel } from '../../../models/quotation.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CetInquiryModalComponent } from './cet-inquiry-modal/cet-inquiry-modal.component';

@Component({
  selector: 'app-cet-inquiry',
  standalone: false,
  templateUrl: './cet-inquiry.component.html',
  styleUrl: './cet-inquiry.component.scss'
})
export class CetInquiryComponent {

  @Input('eventId') eventId: string | null = null;
  quotationRequestList: QuotationRequestModel[] = [];
  quotationRequestResponseModel = new BehaviorSubject<QuotationRequestResponseModel>(new QuotationRequestResponseModel());
  loading: boolean = false;
  searchValue: string = '';
  searchValue$ = new Subject();
  pageIndex = 1;
  pageSize = 30;
  sampleFallbackImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEf0lEQVR4nO3ZS08bVxgG4GmVqlJUVaqo1G6qSpXabsJlZvBljmdsIlVVNl100UU3XXVfcmkAE2JIgnMBZmxsDzgXIvUHZEOatlEaG0gUAi2BVoBSRN2onjEGgw2lCQSHrzrjEOwJpjaML0h+pVfCu3l0znfOGBNEKaWUUvBIXno/LrGXE+RNn0k8CsgCCsqC8SsA4hViL0XijZQsMP2ygCC5koDuz3SYjESxJ+jSlck8cko8E1cjXmB4tC4J6LvwBd27RLEFvPRrEs98Iwkolg7w8uowy5LANP/hPPQ6UQwJ8sZPJJ4ZzxSwRadCDuaLwgEE9LHEM9/vApBaHt0KOZgDeQM8Etm3ZB6dkwW0qhlic7utyQLySu2Wt3MGABvxKj5CJQGFtQZs0Xk8c2Cz7NMUEepAB2UejeUBAKpOyh3GQ7sGBNu59/BRWQAApGw5HvXO8OwHWQPCbssbMs/YZYF5UmiELCD4u4OB4SZqLWtIzMNGC/3wMi6PYPyMHn46Vgm9teWQNQSu1sDTyxaIdJoKhpg6Z4Db9VUKYKM7gmz0yUUzhJ35Az1qZ+BuIwW9hzcBuD8erYhnDVnv2YTgrvdYYEnkIOTIHUASEIye0sGNwxUpgOu15dBXRw7daz3wTtaQf0WTceWi+a9kDG68xwJRD6c5YtKuh5vfJuYgub76KuhvoLLfUur808XB2mVLCgZ39ZIZ5jSYn+nzBvDXpc5Bb2053DxWCXcaKQWCu2vIUhcHuMvdZnjWowZZ4LHXDDMO046O0/snabiumoMbRypgwEqCvyEB0ByitJtTHjyunp+rNYBXLpTJHPDP5+BI6hzgwe63ktDXQKYAcgN53h+OVih7Wr3d1q5YYMHNpkU8PGuAW1vMwe26Khiwbm4jX/4g5XCnkYRJu05ZCTVo5ZIZZpOO60CbUdkuL89BYhttB/DlEoLP+ZGWavilmYZfm2kIXDAol6cahOdqqCnNHDRS4E+zjXz5guBGRRamzhsUCAY9aKlW5keNUd8H/vr0c+ArBGSjEbcJJux6BZM4EFjlaFZDfj6O5yB7gC9fkI3iWzn583I3B/ErFvxakQCojtOihSxt0UWRA3995a4AvmKA4GqB8JUgSSmtSJd2W8vfQOZnRhY8LATaDDmZkcEmauZ3m6Fm15CIy1QbE7nH20Eenk3cIxGXKXFaaQAZsJKrD07RjYSWARuxb8GNvDGRe5YOM9Gqh+k2I4Q7EYy36pVvkzuB9DWQ68M2+lpO/7Ettx18f8HN3sP3gxqCV2RRZOHPNqPy2hJyJlYn4zmor4Khk/TEhI39iMhXIk7u06iHDaesiF3/4u+x09UQaGcyhgyeIOd/O0N9ThQq853oeFRkV7ZanUxmZMBa9XSkpZoniiHgpffPudlriyK7vvmab9wWgr/GDtso/6BN/yZRbJl1mD+MutnR/zt+B5vI6dHW6vz9BrLTzHayX8bcbEwNuXuCWh6z6b4m9lrmXOzpmIddG7CS8ZFm2ot/WyH2ahZdurIJu66s0M9RSimlEMR/TIEr5XGyxMUAAAAASUVORK5CYII="

  constructor(private vm: EventViewModel, private route: ActivatedRoute, private modalService: NzModalService) {
    this.searchValue$.pipe(debounceTime(500)).subscribe(name => {
      this.pageIndex = 1;
      this.getData();
    });
  }

  ngOnInit(): void {
    this.vm.parentCetInquiryComponent = this;
    this.vm.subscribeToQuotationRequest(this.quotationRequestResponseModel);
  }

  getData() {
    this.loading = true
    this.vm.getQuotationRequest(1, 100, this.eventId, 'cet-inquiry', this.searchValue)
  }

  inquaryRecieved() {
    this.quotationRequestList = this.quotationRequestResponseModel.value.results
    this.loading = false
  }

  getOursouringTypeImage(item: any) {
    const image = item?.outsourcing_event_request_details?.outsourcing_type_details?.image;
    return image ? image : ''
  }

  cetInquiryModalRef?: NzModalRef;
  onAdd() {
    this.cetInquiryModalRef = this.modalService.create({
      nzTitle: 'Add New Request',
      nzContent: CetInquiryModalComponent,
      nzFooter: null,
      nzCentered: false,
      nzStyle: {
         top: '50px',
      },
      nzData: {
        eventId: this.eventId
      }
    });

    this.cetInquiryModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });

  }

   formatIdToFourDigits(id: number): string {
    const str = 'RQ'
    return id ? str + id.toString().padStart(4, '0') : '';
  }

  onSearch() {
    this.searchValue$.next(this.searchValue);
  }

  onEditInquery(item:any){
     this.cetInquiryModalRef = this.modalService.create({
      nzTitle: 'Edit Request',
      nzContent: CetInquiryModalComponent,
      nzFooter: null,
      nzCentered: false,
      nzData:{
        data:item,
        eventId: this.eventId
      },
      nzStyle: {
         top: '50px',
      },
  
    });

    this.cetInquiryModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });
  }

  deleteInquery(id:number){
    this.vm.deleteQuotationRequest(id)
  }

  inqueryDeleted(){
    this.getData()
  }

}
